var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorColored(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3882 16.3881L27.6297 27.6296",
    stroke: "#F59300",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3882 27.6296L27.6297 16.3881",
    stroke: "#F59300",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.2055 7.94815C27.6033 7.94831 27.9848 8.10649 28.266 8.38791L35.617 15.7446C35.8982 16.026 36.056 16.4076 36.0559 16.8054L36.0518 27.2053C36.0517 27.6031 35.8935 27.9846 35.6121 28.2658L28.2554 35.6168C27.974 35.898 27.5924 36.0559 27.1946 36.0557L16.7947 36.0516C16.3968 36.0515 16.0154 35.8933 15.7342 35.6119L8.38322 28.2552L7.32214 29.3155L8.38322 28.2552C8.10202 27.9738 7.94414 27.5922 7.94429 27.1944L7.94834 16.7945C7.94849 16.3967 8.10668 16.0152 8.38809 15.734L15.7448 8.38303C16.0262 8.10184 16.4078 7.94395 16.8056 7.9441L27.2055 7.94815Z",
    stroke: "#F59300",
    strokeWidth: 3
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorColored);
export default __webpack_public_path__ + "static/media/error_colored.3e31f29ed4e650fc0a67566ead54061e.svg";
export { ForwardRef as ReactComponent };